import domReady from '@wordpress/dom-ready';

const ROW_END_ITEM_CLASS = 'badges-line__item--last';
const ROW_END_CONNECTOR_CLASS = 'badges-line__connector--last';

function applyRowEnd(item) {
  item.classList.add(ROW_END_ITEM_CLASS);

  const connector = item.querySelector('.badges-line__connector');

  if (connector) {
    connector.classList.add(ROW_END_CONNECTOR_CLASS);
  }
}

function updateRowEnds(list) {
  const items = Array.from(list.querySelectorAll('.badges-line__item'));

  if (2 > items.length) {
    return;
  }

  // The very last item already carries these classes from the server-rendered markup.
  const otherItems = items.slice(0, -1);

  otherItems.forEach((item) => {
    item.classList.remove(ROW_END_ITEM_CLASS);

    const connector = item.querySelector('.badges-line__connector');

    if (connector) {
      connector.classList.remove(ROW_END_CONNECTOR_CLASS);
    }
  });

  otherItems.forEach((item, index) => {
    const nextItem = items[index + 1];

    if (1 < nextItem.offsetTop - item.offsetTop) {
      applyRowEnd(item);
    }
  });
}

domReady(() => {
  const lists = document.querySelectorAll('.badges-line__list');

  if (0 === lists.length) {
    return;
  }

  const recalculateAll = () => lists.forEach(updateRowEnds);
  let resizeFrame = null;

  recalculateAll();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(recalculateAll);
  }

  window.addEventListener('resize', () => {
    if (resizeFrame) {
      cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = requestAnimationFrame(recalculateAll);
  });
});
